import PropTypes from "prop-types";
import ContractWithdrawalLayout from "./containers/contract-withdrawal-layout";
import { WithdrawalFormDetailsProvider } from "./context/withdrawal-details";
import { withdrawalFormDetailsReducer } from "./state/withdrawal-form-details/reducer";
import styles from "./styles";
import { LocaleProvider } from "./context/locale-provider";

export default function App({ storeData }) {
  return (
    <div className={styles.container}>
      <LocaleProvider
        languageStrings={storeData.languageStrings}
        localisedLinks={storeData.localisedLinks}
      >
        <WithdrawalFormDetailsProvider
          initialState={{
            loading: true,
            hasError: false,
            withdrawalFormDetails: {
              contractType: "",
              firstName: "",
              lastName: "",
              email: "",
              orderNumber: "",
              orderDate: "",
              deliveredOn: "",
            },
          }}
          reducer={withdrawalFormDetailsReducer}
        >
          <ContractWithdrawalLayout />
        </WithdrawalFormDetailsProvider>
      </LocaleProvider>
    </div>
  );
}

App.propTypes = {
  storeData: PropTypes.object,
};

App.defaultProps = {
  storeData: {
    languageStrings: {},
    localisedLinks: {},
  },
};
